import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import BestellerDashboardPage from './pages/BestellerDashboardPage';
import PageLoader from './components/PageLoader';
import './App.css';
import './styles/BestellerMobile.css';

// API base URL - wijzig dit naar je webhosting URL
// Voor lokale development: zorg dat XAMPP/Apache draait op localhost
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost/kampboodschappen/backend';

// Axios instance met credentials
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check if user is already authenticated on component mount
  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = async () => {
    try {
      const response = await api.get('/index.php?action=check');
      if (response.data.authenticated) {
        setIsAuthenticated(true);
        setUser(response.data.user);
      }
    } catch (error) {
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="App">
      {isAuthenticated ? (
        user?.rol === 'administrator' ? (
          <DashboardPage user={user} onLogout={handleLogout} />
        ) : (
          <BestellerDashboardPage user={user} onLogout={handleLogout} />
        )
      ) : (
        <LoginPage onLogin={handleLogin} />
      )}
    </div>
  );
}

export { api, API_BASE_URL };
export default App;
